module.exports = __webpack_public_path__ + "img/volume.58a3b31f.svg";